import React, { useEffect, useState } from "react";
import { ScrollView, StyleSheet, View } from "react-native";
import CheckInForm from "./CheckInForm";
import Queries from "../../../api/queries";
import { ApolloQueryResult } from "@apollo/client";
import { BookingOiqiaQl, CheckInData, InfoCardTextProps } from "../../../types/types";
import { Subscription } from "zen-observable-ts";
import { mobUser } from "../../../mobx/MobUser";
import i18n from "../../../i18n";
import InfoCard from "../../../components/InfosCard";
import { formatDate } from "../../../utils/dateFormater";
import { SafeAreaView } from "react-native-safe-area-context";
import FooterDivider from "../../../components/FooterDivider";

export default function CheckIn() {
  const [fields, setFields] = useState<InfoCardTextProps[]>();
  const [checkInInfos, setCheckInInfos] = useState<CheckInData>();
  const queries = new Queries();

  useEffect(() => {

    let checkInDataSubscription: Subscription;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let bookingSubscription: Subscription;
    let timeZone: string | undefined;

    async function subscribeToData() {

      try {
        const BookingInfo = await queries.getBookingById(mobUser.OiqiaBookingId);
        bookingSubscription = BookingInfo.subscribe({
          next(response: ApolloQueryResult<{ NTA_getBookingById: BookingOiqiaQl }>) {
            timeZone = response.data.NTA_getBookingById?.timeZone;
          },
          error(err) {
            console.error("Error fetching booking data:", err);
          }
        });
        const checkInObservable = await queries.getCheckIn(mobUser.OiqiaBookingId);
        checkInDataSubscription = checkInObservable.subscribe({
          next(response: ApolloQueryResult<{ NTA_getCheckIn: CheckInData }>) {
            setCheckInInfos(response.data.NTA_getCheckIn);
            setFields([
              { title: i18n.t("pages.checkIn.arrival"), text: formatDate(response.data.NTA_getCheckIn?.arrival, timeZone) },
              { title: i18n.t("pages.checkIn.departure"), text: formatDate(response.data.NTA_getCheckIn?.departure, timeZone) },
            ]);
          },
          error(err) {
            console.error("Error fetching wifi data:", err);
          }
        });
      } catch (_error) {
        console.error("Error setting up subscription:", _error);
      }
    }

    subscribeToData();

    return () => {
      checkInDataSubscription?.unsubscribe();
    };
  }, []);

  return (
    <SafeAreaView style={{ flex: 1 }} edges={['bottom']}>
      <ScrollView
        contentContainerStyle={styles.container}
        keyboardDismissMode="interactive"
        automaticallyAdjustKeyboardInsets={true}
      >
        <View style={styles.subContainer}>
          <InfoCard fieldMap={fields} />
          <CheckInForm checkInInfos={checkInInfos} />
        </View>
        <FooterDivider />
      </ScrollView>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
  },
  subContainer: {
    marginTop: 20,
    gap: 10,
    width: "80%"
  }
});